import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit/typography';

import { Wrapper } from './Wrapper';
import { IOfferHistoryProps } from './types';

import * as styles from './styles.css';

export const OfferHistory: React.FC<IOfferHistoryProps> = props => {
  return (
    <Wrapper>
      <InlineText1 as="h2" fontWeight="bold">
        {props.title}
      </InlineText1>

      <div className={styles['filters']}>{props.filters}</div>

      <div className={styles['feed']}>{props.feed}</div>

      {props.showMoreBtn}
    </Wrapper>
  );
};

OfferHistory.displayName = 'OfferHistory';
